// extracted by mini-css-extract-plugin
module.exports = {"SidebarMenu":"SidebarMenu_SidebarMenu__2x32l","SidebarItemNested":"SidebarMenu_SidebarItemNested__EBrq0","SidebarMenuCollapse":"SidebarMenu_SidebarMenuCollapse__1oPGp"};